(function () {
  'use strict';

  function init(container) {
    var blocks = container.querySelectorAll('[data-wbvc-block]');
    if (!blocks.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    blocks.forEach(function (block) {
      if (block.dataset.wbvcReady === 'true') return;
      block.dataset.wbvcReady = 'true';
      initBlock(block, prefersReduced);
    });
  }

  function initBlock(block, prefersReduced) {
    var track = block.querySelector('[data-wbvc-track]');
    var dots = Array.prototype.slice.call(block.querySelectorAll('[data-wbvc-dot]'));
    var cards = Array.prototype.slice.call(block.querySelectorAll('[data-wbvc-card]'));

    if (!track || !dots.length || !cards.length) return;

    var current = 0;
    var rafId = null;

    function updateDots(index) {
      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      if (dots[index]) {
        dots[index].classList.add('is-active');
      }

      current = index;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-wbvc-dot'), 10);
        var card = cards[index];

        if (!card) return;

        track.scrollTo({
          left: card.offsetLeft,
          behavior: prefersReduced ? 'auto' : 'smooth'
        });

        updateDots(index);
      });
    });

    track.addEventListener('scroll', function () {
      if (rafId) return;

      rafId = window.requestAnimationFrame(function () {
        rafId = null;

        var trackLeft = track.getBoundingClientRect().left;
        var closest = 0;
        var minDist = Infinity;

        cards.forEach(function (card, index) {
          var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);

          if (dist < minDist) {
            minDist = dist;
            closest = index;
          }
        });

        if (closest !== current) {
          updateDots(closest);
        }
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();